export enum FroalaSize {
    Small = "scss-fr-sm",
    Medium = "scss-fr-md",
    Default = "scss-fr-default"
}

export enum FroalaGalleryMode {
    Email = "Email",
    Website = "Website",
    None = "None"
}

export enum FroalaOptionsKind {
    Default = "Default",
    Attendance = "Attendance",
    Email = "Email",
    Website = "Website",
    SMS = "SMS",
    None = "None"
}

export enum FroalaGalleryTab {
    Gallery = "Gallery",
    Upload = "Upload"
}

export const MusicalNotesFroalaIcons = {
    '&#119133;' : '&#119133; - Whole Note',
    '&#119134;' : '&#119134; - Half Note',
    '&#9833;' : '&#9833; - Quarter Note',
    '&#9834;': '&#9834; - Eighth Note',
    '&#9835;' : '&#9835; - Beamed Eighth Notes',
    '&#119137;': '&#119137; - Sixteenth Note',
    '&#9836;' : '&#9836; - Beamed Sixteenth Notes',
    '&#9837;' : '&#9837; - Flat',
    '&#9838;' : '&#9838; - Natural',
    '&#9839;': '&#9839; - Sharp',

    '&#119099;': '&#119099; - Whole Rest',
    '&#119100;': '&#119100; - Half Rest',
    '&#119101;': '&#119101; - Quarter Rest',
    '&#119102;': '&#119102; - Eighth Rest',
    '&#119103;': '&#119103; - Sixteenth Rest',

    '&#119070;': '&#119070; - Treble Clef',
    '&#119073;': '&#119073; - C Clef',
    '&#119074;': '&#119074; - Bass Clef',
    '&#119077;': '&#119077; - Drum Clef',
};

export const GenericFroalaIcons = {
    '&hearts;' : '&hearts; - Heart',
    '&diams;' : '&diams; - Diamond',
    '&#8734;' : '&#8734; - Infinity',
    '&laquo;' : '&laquo; - Left Double Quote',
    '&raquo;' : '&raquo; - Right Double Quote',
    '&#9786;' : '&#9786; - Smiley',
    '&#10004;' : '&#10004; - Checkmark'
};

export const froalaTextButtons = ['bold', 'italic', 'underline', 'textColor', 'strikeThrough', 'fontSize', 'fontFamily', 'backgroundColor', 'clearFormatting'];
export const froalaParagraphButtons = ['paragraphFormat', 'align', 'formatOL', 'formatUL', 'indent', 'outdent', 'quote', 'lineHeight'];
export const froalaRichButtons = ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'insertHR'];
export const froalaEmailTemplateRichButtons = ['emailPlaceholderDropdown', 'insertLink', 'galleryButton', 'insertTable', 'insertHR'];
export const froalaWebsiteTemplateRichButtons = ['insertLink', 'galleryButton', 'insertVideo', 'insertTable', 'insertHR'];
export const froalaAttendanceRichButtons = ['insertLink', 'insertTable', 'insertHR'];
export const froalaAttendanceMiscButtons = ['undo', 'redo', 'selectAll'];
export const froalaMiscButtons = ['undo', 'redo', 'selectAll', 'html'];
